var _rect, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 241,
    viewBox: "0 0 240 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 56.0879,
    y: 46.1367,
    width: 129.117,
    height: 150.638,
    rx: 26.4,
    fill: "url(#paint0_linear_835_52919)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.648 150.966C121.952 150.966 123.203 150.448 124.126 149.525C125.048 148.603 125.566 147.352 125.566 146.048V107.094L138.485 120.013C139.417 120.882 140.651 121.355 141.925 121.332C143.199 121.31 144.415 120.794 145.316 119.893C146.217 118.991 146.733 117.776 146.756 116.502C146.778 115.227 146.305 113.994 145.436 113.062L124.124 91.7489C123.201 90.8279 121.951 90.3105 120.648 90.3105C119.345 90.3105 118.094 90.8279 117.172 91.7489L95.8593 113.062C95.3761 113.512 94.9885 114.055 94.7197 114.658C94.4509 115.262 94.3064 115.913 94.2947 116.573C94.2831 117.234 94.4045 117.89 94.6519 118.502C94.8993 119.115 95.2675 119.671 95.7345 120.138C96.2015 120.605 96.7579 120.973 97.3703 121.221C97.9827 121.468 98.6387 121.589 99.2991 121.578C99.9595 121.566 100.611 121.422 101.214 121.153C101.817 120.884 102.36 120.496 102.811 120.013L115.73 107.094V146.048C115.73 148.763 117.933 150.966 120.648 150.966Z",
    fill: "url(#paint1_linear_835_52919)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M167.137 141.476C170.832 135.076 180.07 135.076 183.765 141.476L218.194 201.109C221.889 207.509 217.27 215.509 209.88 215.509H141.022C133.631 215.509 129.013 207.509 132.708 201.109L167.137 141.476Z",
    fill: "url(#paint2_linear_835_52919)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M174.855 193.197L175.479 193.163L176.053 193.197C177.246 193.339 178.346 193.914 179.143 194.812C179.941 195.71 180.382 196.87 180.382 198.071C180.382 199.273 179.941 200.433 179.143 201.331C178.346 202.229 177.246 202.804 176.053 202.946L175.43 202.98L174.855 202.946C173.662 202.804 172.563 202.229 171.765 201.331C170.967 200.433 170.527 199.273 170.527 198.071C170.527 196.87 170.967 195.71 171.765 194.812C172.563 193.914 173.662 193.339 174.855 193.197Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M172.169 160.043C173.067 159.244 174.227 158.803 175.43 158.803C176.632 158.803 177.792 159.244 178.691 160.043C179.589 160.842 180.163 161.943 180.304 163.137L180.338 163.711V183.346L180.304 183.92C180.162 185.113 179.587 186.213 178.689 187.01C177.791 187.808 176.631 188.249 175.43 188.249C174.228 188.249 173.069 187.808 172.17 187.01C171.272 186.213 170.697 185.113 170.556 183.92L170.521 183.346V163.711L170.556 163.137C170.696 161.943 171.27 160.842 172.169 160.043Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.496 192.881L176.086 192.916C177.348 193.066 178.511 193.674 179.355 194.624C180.198 195.574 180.664 196.801 180.664 198.071C180.664 199.342 180.198 200.568 179.355 201.518C178.511 202.468 177.348 203.076 176.086 203.226L176.069 203.228L175.413 203.264L174.822 203.226C173.56 203.076 172.398 202.468 171.554 201.518C170.71 200.568 170.244 199.342 170.244 198.071C170.244 196.801 170.71 195.574 171.554 194.624C172.398 193.674 173.56 193.067 174.822 192.917L174.84 192.915L175.496 192.881ZM180.586 163.12L180.621 163.711L180.621 183.363L180.585 183.953C180.435 185.215 179.827 186.378 178.877 187.221C177.927 188.065 176.7 188.531 175.43 188.531C174.159 188.531 172.933 188.065 171.983 187.221C171.033 186.378 170.425 185.215 170.275 183.953L170.273 183.937L170.238 183.346L170.239 163.695L170.275 163.104C170.423 161.841 171.031 160.677 171.981 159.832C172.931 158.987 174.158 158.521 175.43 158.521C176.701 158.521 177.928 158.987 178.878 159.832C179.829 160.677 180.436 161.841 180.584 163.104L180.586 163.12ZM175.43 158.803C174.227 158.803 173.067 159.244 172.169 160.043C171.27 160.842 170.696 161.943 170.556 163.137L170.521 163.711V183.346L170.556 183.92C170.697 185.113 171.272 186.213 172.17 187.01C173.069 187.808 174.228 188.249 175.43 188.249C176.631 188.249 177.791 187.808 178.689 187.01C179.587 186.213 180.162 185.113 180.304 183.92L180.338 183.346V163.711L180.304 163.137C180.163 161.943 179.589 160.842 178.691 160.043C177.792 159.244 176.632 158.803 175.43 158.803ZM175.479 193.163L174.855 193.197C173.662 193.339 172.563 193.914 171.765 194.812C170.967 195.71 170.527 196.87 170.527 198.071C170.527 199.273 170.967 200.433 171.765 201.331C172.563 202.229 173.662 202.804 174.855 202.946L175.43 202.98L176.053 202.946C177.246 202.804 178.346 202.229 179.143 201.331C179.941 200.433 180.382 199.273 180.382 198.071C180.382 196.87 179.941 195.71 179.143 194.812C178.346 193.914 177.246 193.339 176.053 193.197L175.479 193.163Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_835_52919",
    x1: 56.0879,
    y1: 46.1367,
    x2: 219.5,
    y2: 113.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401042,
    stopColor: "#FEE1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677083,
    stopColor: "#FDADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDE6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_835_52919",
    x1: 94.2939,
    y1: 90.3105,
    x2: 160.517,
    y2: 117.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#A554E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#FF00D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A554E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_835_52919",
    x1: 135.906,
    y1: 232.459,
    x2: 223.195,
    y2: 186.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0902216,
    stopColor: "#FF00D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36BDF6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailError);
export default __webpack_public_path__ + "static/media/email_error.93e57de55610d406c73f559974ffdc70.svg";
export { ForwardRef as ReactComponent };